import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domestic',
  templateUrl: './domestic.component.html',
  styleUrls: ['./domestic.component.scss'],
  standalone: false
})
export class DomesticComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
